import {Component} from '@angular/core';
import {VideoFormComponent} from "./Forms/video-form/video-form.component";
import {DocumentFormComponent} from "./Forms/document-form/document-form.component";
import {CertificateFormComponent} from "./Forms/certificate-form/certificate-form.component";
import {BadgeFormComponent} from "./Forms/badge-form/badge-form.component";
import {CourseService} from '../../../pages/courses/course.service';
import {Observable, Subject, take, takeUntil} from 'rxjs';
import {
  CourseContentStructure,
  CourseStructureNode,
  VideoNodeStructure
} from '../../../pages/courses/create-courses/store/course.model';
import {Store} from '@ngrx/store';
import {selectCourseContent, selectCourseId, selectCourseStructure} from '../../../pages/courses/create-courses/store/course.selector';
import * as CourseActions from '../../../pages/courses/create-courses/store/course.action';
import {CommonModule} from '@angular/common';
import {ConfomerService} from '../../../providers/confomer/confomer.service';
import {CourseHelperServiceService} from '../../../pages/courses/course-helper-service.service';

import {CdkDragDrop, CdkDropList, CdkDrag, CdkDragHandle, moveItemInArray} from '@angular/cdk/drag-drop';
import {ToasterService} from '../../../providers/toaster/toaster.service';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {
  courseChapterNameAllowedCharsValidator,
  courseChapterNameMinLengthValidator,
  courseChapterNameMaxLengthValidator,
  courseChapterNameNoAllSpacesValidator,
  courseChapterNameTrimValidator
} from '../../../utils/create_course_validators/structure/videoChapterValidators';

@Component({
  selector: 'app-video-structure',
  standalone: true,
  imports: [VideoFormComponent, DocumentFormComponent, CertificateFormComponent, BadgeFormComponent, CommonModule,RouterModule, CdkDropList, CdkDrag, CdkDragHandle],
  templateUrl: './video-structure.component.html',
  styleUrl: './video-structure.component.scss'
})
export class VideoStructureComponent {

  courseId: any = '';
  isAddingChapter = false;
  courseStructure$!: Observable<CourseContentStructure | null>;
  courseStructureData: any = []
  tempNodeTitle: string = '';
  isAllComponentsVisible: boolean = true
  coursePublished: boolean = false;
  private destroy$ = new Subject<void>();
  savingNodes: Set<number | string> = new Set();

  constructor(private courseApiService: CourseService, private store: Store
    , private confirmDialog: ConfomerService, private helperService: CourseHelperServiceService,
              private toasterService: ToasterService, private route: ActivatedRoute) {
    this.courseStructure$ = this.store.select(selectCourseStructure);
  }


  nextTab(){
    this.helperService.nextTab('details');
  }

  ngOnInit():void {
    this.store.select(selectCourseId).pipe(take(1)).subscribe(value => {
      this.courseId = value;
      if (!this.courseId) {
        this.route.paramMap.subscribe(params => {
          this.courseId = params.get('id') || '';
        });
      }
      this.courseStructure$.pipe(take(1)).subscribe((structure) => {
        if (!structure || structure.data.length === 0) {
          this.store.dispatch(CourseActions.loadStructure({ course_id: this.courseId }));
          this.getData(this.courseId);
        } else {
          this.getDataFromStore();
        }
      });
    });

    // React to publish status changes immediately.
    this.store.select(selectCourseContent)
      .pipe(takeUntil(this.destroy$))
      .subscribe((content: any) => {
        const maybePublished = Number(content?.is_published ?? 0);
        this.coursePublished = maybePublished === 1;
      });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getData(id: any) {
    if (!id) {
      return;
    }

    this.courseApiService.getStructure(id).subscribe((res: any) => {
      try {
        if (res && res.body.status === 'success') {
          if (res.body.data.length > 0) {
            this.store.dispatch(CourseActions.loadStructureSuccess({structure: res.body.data, course_id: id}));
            // this.isAllComponentsVisible = false;
            // setTimeout(() => {
            //   this.isAllComponentsVisible = true;
            // }, 10);
          }
        } else {
          this.store.dispatch(CourseActions.loadStructureSuccess({structure: [], course_id: id}));
        }
        this.getDataFromStore();
      } catch (error) {
        console.log(error);
      }
    });
  };

  getDataFromStore() {
    this.courseStructure$
      .pipe(takeUntil(this.destroy$))
      .subscribe((structure) => {
        if (structure && structure.data.length > 0) {
          const sortedParents = [...structure.data].sort((a: any, b: any) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0));
          this.courseStructureData = sortedParents.map((node: any, parentIndex: number) => {
            const existingNode = this.courseStructureData?.find((n: any) => n.id === node.id);
            const sortedParentMaps = [...(node.structure_maps || [])].sort((a: any, b: any) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0));

            return {
              ...node,
              sort_order: node?.sort_order ?? parentIndex + 1,
              // isEditing: existingNode?.isEditing ?? false,
              isOpen: existingNode?.isOpen ?? true,
              structure_maps: sortedParentMaps.map((mapItem: any, mapIndex: number) => ({
                ...mapItem,
                sort_order: mapItem?.sort_order ?? mapIndex + 1,
              })),
              child: [...(node.child || [])]
                .sort((a: any, b: any) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0))
                .map((child: any, childIndex: number) => {
                  const existingChild = existingNode?.child?.find((c: any) => c.id === child.id);
                  const sortedChildMaps = [...(child.structure_maps || [])].sort((a: any, b: any) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0));

                  return {
                    ...child,
                    sort_order: child?.sort_order ?? childIndex + 1,
                    // isEditing: existingChild?.isEditing ?? false,
                    isOpen: existingChild?.isOpen ?? true,
                    structure_maps: sortedChildMaps.map((mapItem: any, mapIndex: number) => ({
                      ...mapItem,
                      sort_order: mapItem?.sort_order ?? mapIndex + 1,
                    })),
                    grandChild: [...(child.grandChild || [])]
                      .sort((a: any, b: any) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0))
                      .map((grandChild: any, grandChildIndex: number) => {
                        const existingGrandChild = existingChild?.grandChild?.find((gc: any) => gc.id === grandChild.id);
                        const sortedGrandChildMaps = [...(grandChild.structure_maps || [])].sort((a: any, b: any) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0));

                        return {
                          ...grandChild,
                          sort_order: grandChild?.sort_order ?? grandChildIndex + 1,
                          // isEditing: existingGrandChild?.isEditing ?? false,
                          isOpen: existingGrandChild?.isOpen ?? true,
                          structure_maps: sortedGrandChildMaps.map((mapItem: any, mapIndex: number) => ({
                            ...mapItem,
                            sort_order: mapItem?.sort_order ?? mapIndex + 1,
                          }))
                        };
                      })
                  };
                })
            };
          });
        } else {
          this.courseStructureData = []
        }
        // Do not artificially delay rendering; let Angular re-render immediately on data change.
        this.isAllComponentsVisible = true;
      });
  }


  addChapter() {
    if (this.isAddingChapter) return;
    this.isAddingChapter = true;
    try {
      // UI layer: chapter is added immediately locally.
      // Loader is shown while we perform this action.
      this.addNode(1);
    } finally {
      // Since addNode is synchronous, reset immediately.
      this.isAddingChapter = false;
    }
  }

  addNode(lvl: number, parentId?: number | string | 0, childId?: number | string | null) {
    let id = Date.now();
    let parent_id
    if (lvl === 1) parent_id = 0;
    else if (lvl === 2) parent_id = parentId;
    else if (lvl === 3) parent_id = childId;
    const sort_order = this.getNextSortOrder(lvl, parentId, childId);
    let node: CourseStructureNode = {
      id: id,
      parent_id: parent_id || 0,
      course_id: this.courseId,
      structure_name: '',
      description: '',
      structure_maps: [],
      sort_order,
      isEditing: true,
      isOpen: true,
      flag: 1
    }
    if (lvl === 1) {
      node = {...node, child: []};
    } else if (lvl === 2 || lvl === 3) {
      node = {...node, grandChild: []};
    }

    console.log(this.courseStructureData);


    let updatedStructure = this.helperService.addCourseNode(this.courseStructureData, lvl, node, parentId, childId);
    this.courseStructureData = updatedStructure;

    // this.store.dispatch(CourseActions.addCourseNode({ lvl, data: node, parentId, childId }));
    // this.getDataFromStore();

  }

  deleteNewNode(lvl:number, id: number, parentIndex:number, childIndex?: number, grandChildIndex?: number) {
    const upadateStructure = this.helperService.deleteNewNode(this.courseStructureData, lvl, id,parentIndex, childIndex, grandChildIndex);
    this.courseStructureData = upadateStructure;
  }


  addStructureNode(lvl: number, structureType: 'video' | 'certificate' | 'badge', parentId: number | string | 0, childId?: number | string | null, grandChildId?: number | string | null) {
    let structure
    let structureData
    if (structureType === 'video') {
      let videoStructure: VideoNodeStructure = {
        id: 0,
        video_title: '',
        video_link: '',
        video_lock: [],
        is_reel_link: false,
        video_duration: '',
        theory: '',
        theory_lock: [],
        thumbnail: '',
        thumbnail_lock: [],
        no_of_views: '',
        views_lock: [],
        price: '',
        isEditing: true,
        flag: 1,
      };
      structureData = videoStructure;
    } else if (structureType === 'certificate') {
      structureData = {
        id: 0,
        certificate_id: '',
        activities_to_be_considered: '',
        isEditing: true,
        flag: 1,
      };
    } else if (structureType === 'badge') {
      structureData = {
        id: 0,
        badge_id: '',
        activities_to_be_considered: '',
        isEditing: true,
        flag: 1,
      };
    }

    structure = {
      id: 0,
      structure_id: grandChildId ?? childId ?? parentId,
      action_id: 0,
      action_type: structureType,
      video: structureData,
      certificate: structureType === 'certificate' ? structureData : null,
      badge: structureType === 'badge' ? structureData : null,
    }

    let updatedStructure = this.helperService.addStructureNode(this.courseStructureData, lvl, structure, parentId, childId,grandChildId);
    this.courseStructureData = updatedStructure;
  }




  async deleteNode(id: number) {
    let msg = {
      title: 'Delete Node',
      message: 'Are you sure you want to delete this node?'
    }
    const confirmer = await this.confirmDialog.Open(msg.title, msg.message);
    if (confirmer) {
      this.courseApiService.deleteNode(id).subscribe((res: any) => {
        try {
          if (res && res.body.status === 'success') {
            this.getData(this.courseId);
            this.toasterService.setToaster('success', 'deleted_node', res.body.message);
          }
        } catch (error) {
          console.log(error);
        }
      })
    }
  }

  deleteStructureNewNode(index:any) { 
    const updatedStructure = this.helperService.deleteStructureMap(this.courseStructureData, index);
    this.courseStructureData = updatedStructure;
  }

  saveNode(inputId: string, parentId: number | string, flag: number, id: number | string) {
    let value = (document.getElementById(inputId) as HTMLInputElement)?.value || '';
    
    // Clear previous errors
    const errorDiv = document.getElementById(`error_${inputId}`);
    if (errorDiv) {
      errorDiv.classList.add('hidden');
      errorDiv.innerHTML = '';
    }
    (document.getElementById(inputId) as HTMLInputElement)?.classList.remove('error');
    
    // Validate the value
    const validationResult = this.validateChapterName(value);
    if (validationResult) {
      // Show error
      if (errorDiv) {
        errorDiv.classList.remove('hidden');
        errorDiv.innerHTML = validationResult;
      }
      (document.getElementById(inputId) as HTMLInputElement)?.classList.add('error');
      return;
    }
    
    if (value) {
      // Prevent multiple submissions
      if (this.savingNodes.has(id)) {
        return;
      }
      
      // Add node ID to saving set to show loader and prevent duplicate submissions
      this.savingNodes.add(id);
      
      if (flag === 1) {
        const sort_order = this.getNodeSortOrderById(id);
        let data = {
          "course_id": this.courseId,
          "parent_id": parentId ?? 0,
          "structure_name": value,
          "sort_order": sort_order,
          "description": "Dummy description",
        }
        this.courseApiService.addNode(data).subscribe((res: any) => {
          try {
            if (res && res.body.status === 'success') {
              this.toasterService.setToaster('success', 'Node Added', res.body.message);
              this.getData(this.courseId);
            }
          } catch (error) {

          } finally {
            // Remove node ID from saving set to hide loader
            this.savingNodes.delete(id);
          }
        });
      } else if (flag === 0) {
        let data = {"structure_name": value}
        this.courseApiService.updateNode(data, id).subscribe((res: any) => {
          try {
            if (res && res.body.status === 'success') {
              this.toasterService.setToaster('success', 'Node Updated', res.body.message);
              this.getData(this.courseId);
            }
          } catch (error) {
            this.toasterService.setToaster('error', 'failed', res.body.message);
          } finally {
            // Remove node ID from saving set to hide loader
            this.savingNodes.delete(id);
          }

        });
      }
    } else {
      this.toasterService.setToaster('error', 'Field required', 'Please enter a name for the node');
      if (errorDiv) {
        errorDiv.classList.remove('hidden');
        errorDiv.innerHTML = 'Chapter name is required';
      }
      (document.getElementById(inputId) as HTMLInputElement)?.classList.add('error');
      return;
    }
  }
  
  private validateChapterName(value: string): string | null {
    const trimmedValue = value.trim();
    
    // Check if only spaces
    if (trimmedValue.length === 0 && value.length > 0) {
      return 'Name cannot contain only spaces';
    }
    
    // Min length check (3 characters)
    if (trimmedValue.length > 0 && trimmedValue.length < 3) {
      return `Name must be at least 3 characters long (current: ${trimmedValue.length})`;
    }
    
    // Max length check (255 characters)
    if (trimmedValue.length > 255) {
      return `Name must be at most 255 characters (current: ${trimmedValue.length})`;
    }
    
    // Allowed characters check (Alphabets, Numbers, Spaces, -, ., &)
    const allowedCharsRegex = /^[A-Za-z0-9 .&-]+$/;
    if (!allowedCharsRegex.test(trimmedValue)) {
      return 'Name can only contain alphabets, numbers, spaces, hyphens (-), dots (.), and ampersands (&)';
    }
    
    // Trim check (no leading/trailing spaces)
    if (value !== trimmedValue) {
      return 'Name cannot have leading or trailing spaces';
    }
    
    return null;
  }
  
  isNodeSaving(id: number | string): boolean {
    return this.savingNodes.has(id);
  }

  private getNextSortOrder(lvl: number, parentId?: number | string | 0, childId?: number | string | null) {
    if (lvl === 1) {
      return (this.courseStructureData?.length ?? 0) + 1;
    }
    if (lvl === 2) {
      const parent = (this.courseStructureData || []).find((p: any) => String(p.id) === String(parentId));
      return (parent?.child?.length ?? 0) + 1;
    }
    if (lvl === 3) {
      const parent = (this.courseStructureData || []).find((p: any) => String(p.id) === String(parentId));
      const child = (parent?.child || []).find((c: any) => String(c.id) === String(childId));
      return (child?.grandChild?.length ?? 0) + 1;
    }
    return 1;
  }

  private getNodeSortOrderById(id: number | string): number {
    for (const parent of this.courseStructureData || []) {
      if (String(parent.id) === String(id)) return parent.sort_order ?? 0;
      for (const child of parent.child || []) {
        if (String(child.id) === String(id)) return child.sort_order ?? 0;
        for (const grandChild of child.grandChild || []) {
          if (String(grandChild.id) === String(id)) return grandChild.sort_order ?? 0;
        }
      }
    }
    return 0;
  }


  toggleNode(nodeType: number, lvl: number, parentIndex: number, childIndex?: number | null, grandChildIndex?: number | null, contentIndex?: number | null, toggleType: 'edit' | 'visible' = 'edit', inputId?: string, status?: boolean) {
    // this.store.dispatch(CourseActions.toggleEditModeNode({ nodeType, lvl, parentIndex, childIndex, grandChildIndex, contentIndex,toggleType }));
    this.courseStructureData = this.helperService.toggleIsEditingAtLevel(
      this.courseStructureData,
      lvl,
      {
        parentIndex,
        childIndex: childIndex ?? undefined,
        grandChildIndex: grandChildIndex ?? undefined
      },
      nodeType,
      contentIndex ?? undefined,
      toggleType
    );
    console.log(status, toggleType, inputId);

    if (toggleType === 'edit' && inputId) {
      if (status) {
        this.tempNodeTitle = (document.getElementById(inputId ?? '') as HTMLInputElement)?.value || '';
      } else {
        (document.getElementById(inputId ?? '') as HTMLInputElement).classList.remove('error');
        (document.getElementById(inputId ?? '') as HTMLInputElement).value = this.tempNodeTitle;
        this.tempNodeTitle = '';
      }
    }

  }

  // drag and drop functions
  emitData(data: any) {
    const action = data.action || 'get_data';
    const index = data.index || null;
    switch (action) {
      case 'get_data':
        this.getData(this.courseId);
        break;
      case 'delete_video_structure':
        if (index !== null) {
          this.deleteStructureNewNode(index);
        }
        break;
      case 'delete_certificate_structure':
        if (index !== null) {
          this.deleteStructureNewNode(index);
        }
        break;
      case 'delete_badge_structure':
        if (index !== null) {
          this.deleteStructureNewNode(index);
        }
        break;
      default:
        console.warn(`Unknown action: ${action}`);
    }
  }


  parentDrop(event: CdkDragDrop<any[]>) {
    if (!event || event.previousIndex === event.currentIndex) return;

    // When published: keep existing structure order locked.
    if (this.coursePublished) {
      const prev = (this.courseStructureData || [])[event.previousIndex];
      const curr = (this.courseStructureData || [])[event.currentIndex];
      if (prev?.flag !== 1 || curr?.flag !== 1) return;
    }

    const updated = [...(this.courseStructureData || [])];
    moveItemInArray(updated, event.previousIndex, event.currentIndex);
    this.courseStructureData = updated;
    this.applySortOrdersAndPersist();
  }


  childDrop(parentIndex: number, event: CdkDragDrop<any[]>) {
    if (!event || event.previousIndex === event.currentIndex) return;

    // When published: keep existing children order locked (existing parent or children).
    if (this.coursePublished) {
      const parent = (this.courseStructureData || [])[parentIndex];
      const prev = (parent?.child || [])[event.previousIndex];
      const curr = (parent?.child || [])[event.currentIndex];
      if (parent?.flag !== 1 || prev?.flag !== 1 || curr?.flag !== 1) return;
    }

    const updated = [...(this.courseStructureData || [])];
    const parent = { ...(updated[parentIndex] || {}) };
    const children = [...(parent.child || [])];
    moveItemInArray(children, event.previousIndex, event.currentIndex);
    parent.child = children;
    updated[parentIndex] = parent;
    this.courseStructureData = updated;
    this.applySortOrdersAndPersist();
  }


  grandChildDrop(parentIndex: number, childIndex: number, event: CdkDragDrop<any[]>) {
    if (!event || event.previousIndex === event.currentIndex) return;

    // When published: keep existing grand-children order locked.
    if (this.coursePublished) {
      const parent = (this.courseStructureData || [])[parentIndex];
      const child = (parent?.child || [])[childIndex];
      const prev = (child?.grandChild || [])[event.previousIndex];
      const curr = (child?.grandChild || [])[event.currentIndex];
      if (parent?.flag !== 1 || child?.flag !== 1 || prev?.flag !== 1 || curr?.flag !== 1) return;
    }

    const updated = [...(this.courseStructureData || [])];
    const parent = { ...(updated[parentIndex] || {}) };
    const child = { ...(parent.child?.[childIndex] || {}) };
    const grandChildren = [...(child.grandChild || [])];
    moveItemInArray(grandChildren, event.previousIndex, event.currentIndex);
    child.grandChild = grandChildren;
    parent.child = [...(parent.child || [])];
    parent.child[childIndex] = child;
    updated[parentIndex] = parent;
    this.courseStructureData = updated;
    this.applySortOrdersAndPersist();
  }


  structureMapDrop(
    level: 'parent' | 'child' | 'grandChild',
    indices: { parentIndex: number; childIndex?: number; grandChildIndex?: number },
    event: CdkDragDrop<any[]>
  ) {
    if (!event || event.previousIndex === event.currentIndex) return;

    if (this.coursePublished) {
      // When published: do not reorder existing structure maps.
      const parent = (this.courseStructureData || [])[indices.parentIndex];
      if (level === 'parent') {
        const prev = (parent?.structure_maps || [])[event.previousIndex];
        const curr = (parent?.structure_maps || [])[event.currentIndex];
        if (parent?.flag !== 1 || prev?.flag !== 1 || curr?.flag !== 1) return;
      } else if (level === 'child') {
        const childIndex = indices.childIndex ?? 0;
        const child = (parent?.child || [])[childIndex];
        const prev = (child?.structure_maps || [])[event.previousIndex];
        const curr = (child?.structure_maps || [])[event.currentIndex];
        if (parent?.flag !== 1 || child?.flag !== 1 || prev?.flag !== 1 || curr?.flag !== 1) return;
      } else {
        const childIndex = indices.childIndex ?? 0;
        const grandChildIndex = indices.grandChildIndex ?? 0;
        const child = (parent?.child || [])[childIndex];
        const grandChild = (child?.grandChild || [])[grandChildIndex];
        const prev = (grandChild?.structure_maps || [])[event.previousIndex];
        const curr = (grandChild?.structure_maps || [])[event.currentIndex];
        if (parent?.flag !== 1 || child?.flag !== 1 || grandChild?.flag !== 1 || prev?.flag !== 1 || curr?.flag !== 1) return;
      }
    }

    const updated = [...(this.courseStructureData || [])];
    const parent = { ...(updated[indices.parentIndex] || {}) };

    if (level === 'parent') {
      const maps = [...(parent.structure_maps || [])];
      moveItemInArray(maps, event.previousIndex, event.currentIndex);
      parent.structure_maps = maps;
      updated[indices.parentIndex] = parent;
      this.courseStructureData = updated;
      this.applyStructureMapSortOrdersAndPersist('parent', indices);
      return;
    }

    const childIndex = indices.childIndex ?? 0;
    const child = { ...(parent.child?.[childIndex] || {}) };

    if (level === 'child') {
      const maps = [...(child.structure_maps || [])];
      moveItemInArray(maps, event.previousIndex, event.currentIndex);
      child.structure_maps = maps;
      parent.child = [...(parent.child || [])];
      parent.child[childIndex] = child;
      updated[indices.parentIndex] = parent;
      this.courseStructureData = updated;
      this.applyStructureMapSortOrdersAndPersist('child', indices);
      return;
    }

    const grandChildIndex = indices.grandChildIndex ?? 0;
    const grandChild = { ...(child.grandChild?.[grandChildIndex] || {}) };
    const maps = [...(grandChild.structure_maps || [])];
    moveItemInArray(maps, event.previousIndex, event.currentIndex);
    grandChild.structure_maps = maps;
    child.grandChild = [...(child.grandChild || [])];
    child.grandChild[grandChildIndex] = grandChild;
    parent.child = [...(parent.child || [])];
    parent.child[childIndex] = child;
    updated[indices.parentIndex] = parent;
    this.courseStructureData = updated;
    this.applyStructureMapSortOrdersAndPersist('grandChild', indices);
  }


  private applySortOrdersAndPersist() {
    const updated = (this.courseStructureData || []).map((parent: any, parentIndex: number) => {
      const updatedParent = {
        ...parent,
        sort_order: parentIndex + 1,
      };

      const updatedChildren = (parent.child || []).map((child: any, childIndex: number) => {
        const updatedChild = {
          ...child,
          sort_order: childIndex + 1,
        };

        const updatedGrandChildren = (child.grandChild || []).map((grandChild: any, grandChildIndex: number) => ({
          ...grandChild,
          sort_order: grandChildIndex + 1,
        }));

        updatedChild.grandChild = updatedGrandChildren;
        return updatedChild;
      });

      updatedParent.child = updatedChildren;
      return updatedParent;
    });

    this.courseStructureData = updated;
    this.persistSortOrders();
  }

  private persistSortOrders() {
    const updates: Array<{ id: number; sort_order: number; structure_name: string; parent_id: number | string }> = [];

    (this.courseStructureData || []).forEach((parent: any) => {
      if (parent?.flag !== 1 && parent?.id) {
        updates.push({
          id: parent.id,
          sort_order: parent.sort_order ?? 0,
          structure_name: parent.structure_name ?? '',
          parent_id: 0,
        });
      }

      (parent?.child || []).forEach((child: any) => {
        if (child?.flag !== 1 && child?.id) {
          updates.push({
            id: child.id,
            sort_order: child.sort_order ?? 0,
            structure_name: child.structure_name ?? '',
            parent_id: parent.id ?? 0,
          });
        }

        (child?.grandChild || []).forEach((grandChild: any) => {
          if (grandChild?.flag !== 1 && grandChild?.id) {
            updates.push({
              id: grandChild.id,
              sort_order: grandChild.sort_order ?? 0,
              structure_name: grandChild.structure_name ?? '',
              parent_id: child.id ?? 0,
            });
          }
        });
      });
    });

    if (updates.length === 0) return;

    updates.forEach((item) => {
      this.courseApiService
        .updateNode(
          {
            sort_order: item.sort_order,
            structure_name: item.structure_name,
          },
          item.id
        )
        .subscribe({
          error: (error) => {
            console.error('Failed to update sort order', error);
          },
        });
    });
  }

  private applyStructureMapSortOrdersAndPersist(
    level: 'parent' | 'child' | 'grandChild',
    indices: { parentIndex: number; childIndex?: number; grandChildIndex?: number }
  ) {
    const updated = [...(this.courseStructureData || [])];
    const parent = { ...(updated[indices.parentIndex] || {}) };

    if (level === 'parent') {
      const maps = (parent.structure_maps || []).map((mapItem: any, mapIndex: number) => ({
        ...mapItem,
        sort_order: mapIndex + 1,
      }));
      parent.structure_maps = maps;
      updated[indices.parentIndex] = parent;
      this.courseStructureData = updated;
      this.persistStructureMapSortOrders(maps);
      return;
    }

    const childIndex = indices.childIndex ?? 0;
    const child = { ...(parent.child?.[childIndex] || {}) };

    if (level === 'child') {
      const maps = (child.structure_maps || []).map((mapItem: any, mapIndex: number) => ({
        ...mapItem,
        sort_order: mapIndex + 1,
      }));
      child.structure_maps = maps;
      parent.child = [...(parent.child || [])];
      parent.child[childIndex] = child;
      updated[indices.parentIndex] = parent;
      this.courseStructureData = updated;
      this.persistStructureMapSortOrders(maps);
      return;
    }

    const grandChildIndex = indices.grandChildIndex ?? 0;
    const grandChild = { ...(child.grandChild?.[grandChildIndex] || {}) };
    const maps = (grandChild.structure_maps || []).map((mapItem: any, mapIndex: number) => ({
      ...mapItem,
      sort_order: mapIndex + 1,
    }));
    grandChild.structure_maps = maps;
    child.grandChild = [...(child.grandChild || [])];
    child.grandChild[grandChildIndex] = grandChild;
    parent.child = [...(parent.child || [])];
    parent.child[childIndex] = child;
    updated[indices.parentIndex] = parent;
    this.courseStructureData = updated;
    this.persistStructureMapSortOrders(maps);
  }

  private persistStructureMapSortOrders(maps: any[]) {
    if (!maps || maps.length === 0) return;

    maps.forEach((mapItem: any) => {
      if (mapItem?.action_type !== 'video') return;
      if (!mapItem?.id || mapItem?.flag === 1) return;

      const formData = this.buildVideoUpdateFormData(mapItem);
      formData.append('sort_order', String(mapItem.sort_order ?? 0));
      console.log('Persisting sort order for map item:', mapItem);
      this.courseApiService.updateVideoNode(formData, mapItem.action_id).subscribe({
        error: (error) => {
          console.error('Failed to update video sort order', error);
        },
      });
    });
  }

  private buildVideoUpdateFormData(mapItem: any): FormData {
    const video = mapItem?.video || {};
    const formData = new FormData();

    formData.append('course_id', String(this.courseId ?? video.course_id ?? 0));
    formData.append('structure_id', String(mapItem?.structure_id ?? video.structure_id ?? 0));
    formData.append('video_title', String(video.video_title ?? ''));
    formData.append('video_link', String(video.video_link ?? ''));
    formData.append('video_duration', String(video.video_duration ?? 0));
    formData.append('theory', String(video.theory ?? ''));
    formData.append('no_of_views', String(video.no_of_views ?? ''));
    formData.append('price', String(video.price ?? ''));
    formData.append('is_reel_link', video.is_reel_link ? '1' : '0');

    if (video.thumbnail instanceof File || video.thumbnail instanceof Blob) {
      formData.append('thumbnail', video.thumbnail);
    } else {
      formData.append('thumbnail', video.thumbnail ?? '');
    }

    if (video.video_file instanceof File || video.video_file instanceof Blob) {
      formData.append('video_file', video.video_file);
    } else {
      formData.append('video_file', video.video_file ?? '');
    }

    formData.append('is_active', '1');

    (this.helperService.toArray(video.video_lock) ?? []).forEach((item: string) => {
      formData.append('video_lock[]', item);
    });
    (this.helperService.toArray(video.theory_lock) ?? []).forEach((item: string) => {
      formData.append('theory_lock[]', item);
    });
    (this.helperService.toArray(video.thumbnail_lock) ?? []).forEach((item: string) => {
      formData.append('thumbnail_lock[]', item);
    });
    (this.helperService.toArray(video.views_lock) ?? []).forEach((item: string) => {
      formData.append('views_lock[]', item);
    });

    return formData;
  }

}
